import { useEffect, useState } from "react";
import { Formik } from "formik";
import { Grid, TextField, FormLabel, Select, MenuItem } from "@mui/material";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { CustomSnackbar } from "../../../components/common/CustomSnackbar/CustomSnackbar";

export const SectionGeneralData: React.FC<any> = (props:any): JSX.Element | any => {

    const { dataGeneral, setDataGeneral, currentSection, handlePrevSection, handleNextSection, sections, clearState } = props;

    const [loadingdata, setLoadingdata] = useState<boolean>(false);
    const [state, setState] = useState<any>({
        client: true,
        supplier: true,
    });

    const validateForm = (values:any) => {
        let errors:any = {};
        if(!values.rut) errors.rut = "el campo es requerido";
        if(!values.name_rz) errors.name_rz = "el campo es requerido";
        if(!values.phone) errors.phone = "el campo es requerido";
        if(!values.email) errors.email = "el campo es requerido";
        return errors;
    }

    const OnCheckbox = (e) => {
        setState({
            ...state,
            [e.target.name]: e.target.checked,
        });
    }

    const onSubmit = async(values)  => {
        if(!state.client && !state.supplier ) return CustomSnackbar('warning', "Seleccione Cliente o Proveedor");
        const type = state.client && state.supplier ? '3' : (state.client && !state.supplier ? '1' : '2');

        setDataGeneral({...values, type:type})
        handleNextSection && handleNextSection();
    }

    return (
        <Grid sx={{height:'100%', position: 'relative'}}>
            <Formik initialValues={dataGeneral} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <Grid container sx={{maxHeight: '65vh', overflowY: 'scroll', paddingRight:'5px'}}>
                                <Grid item container xs={12} spacing={2}>
                                <Grid item xs={12}>
                                    <div>
                                        <FormControlLabel control={<Checkbox checked={state.client} onChange={OnCheckbox} />} label="Cliente" name="client"/>
                                        <FormControlLabel control={<Checkbox checked={state.supplier} onChange={OnCheckbox} />} label="Proveedor" name="supplier"/>
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormLabel>Rut:</FormLabel>
                                    <TextField
                                        id="rut"
                                        type="text" 
                                        name="rut"
                                        fullWidth
                                        size="small"
                                        value={values.rut}
                                        onChange={handleChange}
                                        error={errors.rut && touched.rut ? true : false}
                                        inputProps={{
                                            maxLength: 10,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormLabel>Razon social:</FormLabel>
                                    <TextField
                                        id="name_rz"
                                        type="text" 
                                        name="name_rz"
                                        fullWidth
                                        size="small"
                                        value={values.name_rz}
                                        onChange={handleChange}
                                        error={errors.name_rz && touched.name_rz ? true : false}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormLabel>Nombre de fantasía:</FormLabel>
                                    <TextField
                                        id="fantasy_name"
                                        type="text" 
                                        name="fantasy_name"
                                        fullWidth
                                        size="small"
                                        value={values.fantasy_name}
                                        onChange={handleChange}
                                        error={errors.fantasy_name && touched.fantasy_name ? true : false}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormLabel>Giro de la empresa:</FormLabel>
                                    <TextField
                                        id="giro"
                                        type="text" 
                                        name="giro"
                                        fullWidth
                                        size="small"
                                        value={values.giro}
                                        onChange={handleChange}
                                        error={errors.giro && touched.giro ? true : false}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormLabel>Teléfono:</FormLabel>
                                    <TextField
                                        id="phone"
                                        type="text" 
                                        name="phone"
                                        fullWidth
                                        size="small"
                                        value={values.phone}
                                        onChange={handleChange}
                                        error={errors.phone && touched.phone ? true : false}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormLabel>Correo:</FormLabel>
                                    <TextField
                                        id="email"
                                        type="email" 
                                        name="email"
                                        fullWidth
                                        size="small"
                                        value={values.email}
                                        onChange={handleChange}
                                        error={errors.email && touched.email ? true : false}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormLabel>Fax:</FormLabel>
                                    <TextField
                                        id="fax"
                                        type="text" 
                                        name="fax"
                                        fullWidth
                                        size="small"
                                        value={values.fax}
                                        onChange={handleChange}
                                        error={errors.fax && touched.fax ? true : false}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormLabel>Web:</FormLabel>
                                    <TextField
                                        id="web"
                                        type="text" 
                                        name="web"
                                        fullWidth
                                        size="small"
                                        value={values.web}
                                        onChange={handleChange}
                                        error={errors.web && touched.web ? true : false}
                                    />
                                </Grid>
                                </Grid>
                            </Grid>
                            <div style={{ position: 'absolute', bottom: 0, width: '100%' }}>
                                <ModalFooter
                                    buttonType="submit"
                                    confirmText={'Siguiente'}
                                    onConfirm={handleSubmit}
                                />
                            </div>
                        </form>
                    )
                }} 
            </Formik>
        </Grid>
    )
}